import { Box, Flex } from '@lego/klik-ui';
import { BreadCrumb } from '@/components/common';
import { ServiceTagsTable } from '@/components/common/table/ServiceTagsTable';
import { StoreServiceDetails } from '@/components/store/StoreServiceDetails';
import { useDocumentTitle } from '@/hooks/common';
import type { StoreService } from '@/hooks/store';
import { useRegisterPageContext } from '@/providers/PageContextProvider';
import { paths } from '@/utility/global_paths';

type Props = {
  service: StoreService;
};

export const StoreServicePage = ({ service }: Props) => {
  useRegisterPageContext(service);
  useDocumentTitle(service.name);
  return (
    <Box>
      <Box>
        <BreadCrumb
          crumbs={[
            { label: 'Store', path: paths.store },
            {
              label: service.name,
              path: paths.storeByServiceName(service.name),
            },
          ]}
        />
      </Box>
      <Flex direction="column" gap={8} marginY={8}>
        <StoreServiceDetails service={service} />
        <ServiceTagsTable imageName={service.imageName} tags={service.tags} />
      </Flex>
    </Box>
  );
};
